var map = {
	"./add-circle.svg": "876a",
	"./add.svg": "c2a3",
	"./backtop.svg": "79b3",
	"./copy.svg": "19b6",
	"./good.svg": "9765",
	"./minus-circle.svg": "a2c7",
	"./minus.svg": "dc8f",
	"./qq.svg": "1430",
	"./save.svg": "0e55",
	"./search.svg": "8e8d",
	"./share.svg": "5306",
	"./snapped.svg": "c6fc",
	"./star.svg": "708a",
	"./user.svg": "b3b5",
	"./wechat.svg": "80da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";